module.exports = __webpack_public_path__ + "img/2025-home-header.244b8338.png";